import {setInterval} from '@acng/frontend-bounty/dom/window.js';
import {resolved} from '@acng/frontend-bounty/std/control.js';
import {from} from '@acng/frontend-bounty/std/array.js';
import {createSet, clear, add, has} from '@acng/frontend-bounty/collection.js';
import {ARRAY, STRING, guard} from '@acng/frontend-rubicon';
import {createGlobalContext} from '@acng/frontend-relativity';
import {CTX_PROVIDE} from '@acng/frontend-relativity/minify';

import {inject} from 'acng/core/service/ng';
import {API_cdn} from 'acng/core/service/env';
import {handleCfChallenge} from '../../core/service/backend/cf-challenge.js';

const MODULE = 'amateurPool/service/online';
const VERBOSE = false;

/**
 * @param {string} amateurId
 */
export const isOnline = (amateurId) => has(online, amateurId);

/**
 * Observe the (messenger-) online state of Amateurs.
 */
export const ctxOnline = createGlobalContext(isOnline);

/**
 * @type {Set<string>}
 */
export const online = createSet();

/**
 * @param {string[]} list
 *
 * @returns {Promise<string[]>}
 */
export async function onlineFirst(list) {
  return list.slice().sort((a, b) => {
    const indexA = online.has(a) ? 1 : -1;
    const indexB = online.has(b) ? 1 : -1;
    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
}

/**
 * @deprecated
 */
export const getOnlineArray = async () => {
  await init;
  return from(online);
};

/**
 * @returns {Promise<void>}
 */
const fetchOnline = async () => {
  const res = await fetch(`${API_cdn}/api/amateur-profile/online`);

  handleCfChallenge(res);

  if (!res.ok) {
    return;
  }

  clear(online);

  const data = await res.json();

  ASSERT: guard(data, ARRAY(STRING));

  for (const id of data) {
    add(online, id);
  }

  DEBUG: VERBOSE && console.info(MODULE, online);

  init = resolved(undefined);
  ctxOnline[CTX_PROVIDE](null, isOnline);

  try {
    inject('$rootScope').$digest();
  } catch (reason) {
    //
  }
};

let init = fetchOnline();
setInterval(fetchOnline, 30e3);
